module.exports = __webpack_public_path__ + "ga.svg?db05199787b0c1a71f566d5c7ec7cf0b";